<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 17.2C19 17.7523 18.5523 18.2 18 18.2H2C1.44772 18.2 1 17.7523 1 17.2V3C1 2.44772 1.44772 2 2 2H18C18.5523 2 19 2.44772 19 3V17.2Z"
    stroke="#002D72"
    stroke-width="1.2"
    stroke-linejoin="round"
  />
  <mask [attr.id]="'path-2-inside-1_982_6092-' + idSuffix" fill="white">
    <ellipse cx="4.60068" cy="6.49985" rx="0.9" ry="0.9" />
  </mask>
  <ellipse cx="4.60068" cy="6.49985" rx="0.9" ry="0.9" fill="black" />
  <path
    d="M4.30068 6.49985C4.30068 6.33417 4.435 6.19985 4.60068 6.19985V8.59985C5.76048 8.59985 6.70068 7.65965 6.70068 6.49985H4.30068ZM4.60068 6.19985C4.76637 6.19985 4.90068 6.33417 4.90068 6.49985H2.50068C2.50068 7.65965 3.44089 8.59985 4.60068 8.59985V6.19985ZM4.90068 6.49985C4.90068 6.66554 4.76637 6.79985 4.60068 6.79985V4.39985C3.44089 4.39985 2.50068 5.34006 2.50068 6.49985H4.90068ZM4.60068 6.79985C4.435 6.79985 4.30068 6.66554 4.30068 6.49985H6.70068C6.70068 5.34006 5.76048 4.39985 4.60068 4.39985V6.79985Z"
    fill="#002D72"
    [attr.mask]="'url(#path-2-inside-1_982_6092-' + idSuffix + ')'"
  />
  <mask [attr.id]="'path-4-inside-2_982_6092-' + idSuffix" fill="white">
    <ellipse cx="4.60068" cy="10.0998" rx="0.9" ry="0.9" />
  </mask>
  <ellipse cx="4.60068" cy="10.0998" rx="0.9" ry="0.9" fill="black" />
  <path
    d="M4.30068 10.0998C4.30068 9.93414 4.435 9.79983 4.60068 9.79983V12.1998C5.76048 12.1998 6.70068 11.2596 6.70068 10.0998H4.30068ZM4.60068 9.79983C4.76637 9.79983 4.90068 9.93414 4.90068 10.0998H2.50068C2.50068 11.2596 3.44089 12.1998 4.60068 12.1998V9.79983ZM4.90068 10.0998C4.90068 10.2655 4.76637 10.3998 4.60068 10.3998V7.99983C3.44089 7.99983 2.50068 8.94003 2.50068 10.0998H4.90068ZM4.60068 10.3998C4.435 10.3998 4.30068 10.2655 4.30068 10.0998H6.70068C6.70068 8.94003 5.76048 7.99983 4.60068 7.99983V10.3998Z"
    fill="#002D72"
    [attr.mask]="'url(#path-4-inside-2_982_6092-' + idSuffix + ')'"
  />
  <mask [attr.id]="'path-6-inside-3_982_6092-' + idSuffix" fill="white">
    <ellipse cx="4.60068" cy="13.6998" rx="0.9" ry="0.9" />
  </mask>
  <ellipse cx="4.60068" cy="13.6998" rx="0.9" ry="0.9" fill="black" />
  <path
    d="M4.30068 13.6998C4.30068 13.5341 4.435 13.3998 4.60068 13.3998V15.7998C5.76048 15.7998 6.70068 14.8596 6.70068 13.6998H4.30068ZM4.60068 13.3998C4.76637 13.3998 4.90068 13.5341 4.90068 13.6998H2.50068C2.50068 14.8596 3.44089 15.7998 4.60068 15.7998V13.3998ZM4.90068 13.6998C4.90068 13.8655 4.76637 13.9998 4.60068 13.9998V11.5998C3.44089 11.5998 2.50068 12.54 2.50068 13.6998H4.90068ZM4.60068 13.9998C4.435 13.9998 4.30068 13.8655 4.30068 13.6998H6.70068C6.70068 12.54 5.76048 11.5998 4.60068 11.5998V13.9998Z"
    fill="#002D72"
    [attr.mask]="'url(#path-6-inside-3_982_6092-' + idSuffix + ')'"
  />
  <path d="M7.30078 6.49988H15.4008" stroke="#002D72" stroke-width="1.2" stroke-linecap="round" />
  <path d="M7.30078 10.0999H15.4008" stroke="#002D72" stroke-width="1.2" stroke-linecap="round" />
  <path d="M7.30078 13.6998H15.4008" stroke="#002D72" stroke-width="1.2" stroke-linecap="round" />
</svg>
